import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import TitleBasic, {titleBasicSizes} from '@adv-mt/mt-title-basic'

const BASE_CLASS = 'mt-UserProfileInfo'
const LIST_CLASS = `${BASE_CLASS}List`

const UserProfileInfo = ({email, phone, province: provinceId}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const provinces = config.get('provinces')

  const provinceName = provinceId && provinces.find(province => province.id === Number(provinceId))?.label

  return (
    <div className={BASE_CLASS}>
      <ul className={LIST_CLASS}>
        {email ? (
          <li>
            <TitleBasic size={titleBasicSizes.xs} title={email} preTitle={i18n.t('USER_PROFILE.INFO.EMAIL')} />
          </li>
        ) : null}
        {provinceName ? (
          <li>
            <TitleBasic
              size={titleBasicSizes.xs}
              title={provinceName}
              preTitle={i18n.t('USER_PROFILE.INFO.PROVINCE')}
            />
          </li>
        ) : null}
        {phone ? (
          <li>
            <TitleBasic size={titleBasicSizes.xs} title={phone} preTitle={i18n.t('USER_PROFILE.INFO.PHONE')} />
          </li>
        ) : null}
      </ul>
    </div>
  )
}

UserProfileInfo.propTypes = {
  email: PropTypes.string,
  phone: PropTypes.string,
  province: PropTypes.string
}

export default UserProfileInfo
